module.exports = __webpack_public_path__ + "static/img/11.d3fb7e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/sp/11.png
// module id = Om7o
// module chunks = 0